import eLife from '@/views/eLife'

export default {
  path: '/eLife',
  component: eLife,
  name: 'eLife',
  meta: {
    title: 'e惠民生'
  },
  children: [
    {
      path: 'policy',
      component: () => import('@/views/eLife/Policy'),
      name: 'Policy',
      meta: {
        title: '政策知晓'
      }
    }
  ]
}
